import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { border, borderBottom, fontSize, fontWeight, height, margin, minWidth, padding, textAlign, width } from '@material-ui/system'; // `border`, `margin`, and `textAlign` are unused; consider removing.
import { Background } from 'reactflow'; // `Background` is unused; consider removing.

export const TempoStyleSheet = makeStyles<Theme>((theme: Theme) =>
    createStyles({
        tempoContainer: {
            '& li.MuiMenuItem-root': {
                paddingLeft: '0px !important'
            },
            // padding: '32px 16px 32px 16px',

            '& .menuFilterItem': {

                '& li.MuiButtonBase-root.MuiMenuItem-root.MuiMenuItem-gutters': {
                    paddingLeft: '0px',
                    fontSize: '10px',
                    borderBottom: 'solid 1px red'
                },
                'span.MuiTypography-root': {
                    fontSize: '14px',
                },
                '& .menuFilterHeader': {
                    color: '#8492A6',
                    fontSize: '10px',
                    minWidth: '70px',
                    textAlign: 'left',
                    fontWeight: 600,
                    lineHeight: '16px',
                    letterSpacing: '0.06em',
                    textUnderlinePosition: 'from-font',
                    textDecorationSkipInk: 'none',
                },
            },


            '& .textHeading': {
                padding: '16.5px 0px 0px 0px',
            },
            '& thead': {
                background: '#fafafb',
            },
            '& th': {
                minWidth: '70px',
                fontSize: '10px',
                fontWeight: 600,
                lineHeight: '16px',
                letterSpacing: '0.06em',
                textAlign: 'center',
                textUnderlinePosition: 'from-font',
                textDecorationSkipInk: 'none',
                color: '#8492A6',
            },
            '& th:nth-child(1)': {
                minWidth: '250px',
                textAlign: 'left',
                borderRight: '1px solid #e0e0e0',
            },
            '& th:nth-child(2)': {
                minWidth: '100px',
                textAlign: 'center',
            },
            '& td:nth-child(1)': {
                borderRight: '1px solid #e0e0e0',
            },
            '& td': {
                textAlign: 'center',
                borderBottom: '1px solid #e0e0e0',
                fontSize: '12px',
                fontWeight: 400,
                lineHeight: '20px',
                textUnderlinePosition: 'from-font',
                textDecorationSkipInk: 'none',
                color: '#425466', 
            },
            '& .profileNameImg': {
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
            },

            '& .optionSection': {
                // '& .MuiGrid-item': {
                //     padding: '0px'
                // },
                '& .MuiInputBase-root': {
                    // fontSize: '12px',
                    // maxHeight: '30px'
                },
                '& .LeftSection': {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    width: '100%',
                    gap: '10px',
                    marginTop: '20px',
                    marginBottom: '7px',
                    '& .btnReset': {
                        // padding: '0px',
                        '& SVG': {
                            // width: '16px',
                            // height: '30px'
                        }
                    },
                    "& .SearchBox": {
                        minWidth: '240px'
                    },
                    '& .MuiSelect-select': {
                        padding: '10px'
                    },
                    '& .MuiInputBase-input': {
                        padding: '10px'
                    },
                    '& .filterSec': {
                        '& .MuiInputLabel-root  ': {
                            fontSize: '12px !important',
                            top: '0px !important',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            width: '60px'
                        },
                        'label[data-shrink=false]': {
                            top: "-3px",
                        },
                    },
                    '& .MuiFormLabel-root': {

                        fontWeight: '600 !important',
                        background: 'white',
                        padding: '2px'
                    },
                },
            },
            '& .filterViewBox': {
                marginBottom: '10px'
            },
            '& .RightSection': {
                '& .SearchBox': {
                    textAlign: 'right',
                },
            },
            '& .SearchBox': {
                '& div:nth-child(1)': {
                    margin: '0px 0px',
                },
            },
        },
    })
);
